<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="book-i">
<h1 style=" font-family:Arial; font-size:16pt;margin-top:180pt;">Book I</h1>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0006.vue?2156c656